export default "/images/vendor/flag-icons/flags/1x1/fr.svg?9e329b0fd412c860b31a0ceb88b3c681";